// extracted by mini-css-extract-plugin
export var LabPage = "LabPage-module--LabPage--uraZ+";
export var hero = "LabPage-module--hero--ixe9z";
export var description = "LabPage-module--description--1mGh4";
export var footer = "LabPage-module--footer--9fVDn";
export var hiddenFooter = "LabPage-module--hiddenFooter--7UAU-";
export var fadeIn = "LabPage-module--fadeIn--rhFzi";